export class DocumentsFiling {
      Id: string;
      Tenant: number;
      DocumentId: string;
      Code: string;
      DocumentTypeId: string;
      DocumentTypeName: string;
      DocumentTypeCode: string;
      FileExtension: string;
      FileSize: number | null;
      FileName: string;
      DoucmentTypeTemplateFormatCode: string;
      EntityId: string;
      ObjectTableId: string;
      EntityNumber: string;
      ObjectTableName: string;
      SecurityId: string;
      HasFile: boolean;
      Received: boolean;
      ReceivedByUserId: string | null;
      ReceivedByUserName: string;
      ReceivedDate: Date | null;
      IsUoloadedField: boolean;
}